const icons = {
  upload: ['M12 16V3m-5 5 5-5 5 5', 'M4 15v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5'],
  image: ['M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z', 'm3 16 5-5 5 5 3-3 5 5', 'M16 7h.01'],
  grid: ['M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z'],
  users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M17 4a4 4 0 0 1 0 8m5 9v-2a4 4 0 0 0-3-3.87'],
  settings: ['M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z', 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8'],
  folder: ['M3 7V5a1 1 0 0 1 1-1h5l2 3h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7Z'],
  link: ['m10 13 4-4', 'M8 15 6 17a3.5 3.5 0 0 1-5-5l4-4a3.5 3.5 0 0 1 5 0', 'm14 16 4-4a3.5 3.5 0 0 0-5-5l-2 2'],
  clock: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18', 'M12 7v5l3 2'],
  sun: ['M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8', 'M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1 1m12 12 1 1M5 19l1-1M18 6l1-1'],
  moon: ['M21 13A9 9 0 0 1 11 3a9 9 0 1 0 10 10Z'],
  monitor: ['M3 3h18v13H3zM8 21h8m-4-5v5'],
  arrow: ['M5 12h14m-5-5 5 5-5 5'],
  book: ['M12 5v16M3 3c4 0 7 0 9 2 2-2 5-2 9-2v16c-4 0-7 0-9 2-2-2-5-2-9-2Z'],
  menu: ['M4 6h16M4 12h16M4 18h16'],
  close: ['m6 6 12 12M6 18 18 6'],
  check: ['m5 12 4 4L19 6'],
  chevron: ['m9 5 7 7-7 7'],
  logout: ['M9 3H4v18h5m5-16 7 7-7 7m-7-7h14'],
  globe: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18', 'M3 12h18M12 3c5 5 5 13 0 18-5-5-5-13 0-18'],
  tune: ['M4 7h4m6 0h6M4 17h10m6 0h0', 'M8 4h6v6H8zM14 14h6v6h-6z'],
  cloud: ['M7 18H6a5 5 0 0 1-1-10 7 7 0 0 1 13-1 5.5 5.5 0 0 1 0 11h-1', 'M12 20V11m-3 3 3-3 3 3'],
  spark: ['m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z']
};
export default {
  name: 'UiIcon',
  props: {
    name: {
      type: String,
      default: 'image'
    }
  },
  computed: {
    paths() {
      return icons[this.name] || icons.image;
    }
  }
};